import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5 flex-wrap" }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = { class: "flex items-center gap-1" }
const _hoisted_4 = ["onClick"]

import { computed } from 'vue'
import { useDocumentsStore } from '../store'
import { DOCUMENT_REACTIONS } from '@/types'

import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { SmilePlus } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentReactions',
  props: {
    documentId: {},
    reactions: {},
    actorId: {}
  },
  setup(__props: any) {

const props = __props

const documentsStore = useDocumentsStore()

const activeReactions = computed(() => {
  if (!props.reactions) return []
  return Object.entries(props.reactions)
    .filter(([, actors]) => actors.length > 0)
    .map(([emoji, actors]) => ({
      emoji,
      count: actors.length,
      hasReacted: props.actorId ? actors.includes(props.actorId) : false,
    }))
})

const handleToggle = (emoji: string) => {
  if (!props.actorId) return
  documentsStore.toggleReaction(props.documentId, emoji, props.actorId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeReactions.value, (reaction) => {
      return (_openBlock(), _createElementBlock("button", {
        key: reaction.emoji,
        class: _normalizeClass(["inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border transition-colors", [
        reaction.hasReacted
          ? 'bg-primary/10 border-primary/30 text-primary'
          : 'bg-muted border-transparent text-muted-foreground',
        __props.actorId ? 'hover:bg-muted/80 cursor-pointer' : 'cursor-default',
      ]]),
        disabled: !__props.actorId,
        onClick: ($event: any) => (handleToggle(reaction.emoji))
      }, [
        _createElementVNode("span", null, _toDisplayString(reaction.emoji), 1),
        _createElementVNode("span", null, _toDisplayString(reaction.count), 1)
      ], 10, _hoisted_2))
    }), 128)),
    (__props.actorId)
      ? (_openBlock(), _createBlock(_unref(Popover), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  size: "icon",
                  class: "h-6 w-6 rounded-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SmilePlus), { class: "h-3.5 w-3.5 text-muted-foreground" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(PopoverContent), {
              class: "w-auto p-2",
              align: "start"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DOCUMENT_REACTIONS), (emoji) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: emoji,
                      class: "h-8 w-8 flex items-center justify-center rounded hover:bg-muted transition-colors text-base",
                      onClick: ($event: any) => (handleToggle(emoji))
                    }, _toDisplayString(emoji), 9, _hoisted_4))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})